import styled from 'styled-components';
import { SvgIcon } from '@material-ui/core';


export const FixedSizeIcon = styled(SvgIcon)`
    margin: 30px;
    transform: scale(3.67);
`;
